<template>
  <!--background-color:#0B1640;-->
  <div style="width:100%;color: #75C3FF;">
    <div class="text-flex">
      <div style="width:30%;height: 100%;">
        <data-parameter></data-parameter>
      </div>
      <div style="width:70%;height: 100%;">
        <Eachars @statue="upstatue"></Eachars>
      </div>
    </div>
  </div>
</template>
<script>
  import "echarts/map/js/china.js"
  import Eachars from './Eachars.vue'
  import DataParameter from './DataParameter'
  export default {
    components:{
      Eachars,DataParameter,/*name:'content',*/
    },
    data(){
      return{
        mapList:  [],
        Devicedata:""
      }
    },
    mounted(){

    },
    methods:{
      upstatue(res){
        this.Devicedata=res
        /*this.bus.$emit()*/
      }
    }
  }
</script>
<style scoped>
  /*div{*/
    /*display: inline-block;*/
  /*}*/
  .text-flex{
    display: flex;
    height: 54vh;
    margin-bottom: 1vh;
    /*justify-content:space-around;*/
  }
</style>




// WEBPACK FOOTER //
// src/components/Index/common/Content.vue